module.exports = __webpack_public_path__ + "static/media/01d.c2fac50a.png";